export function getLanguage() {
    const language = document.getElementsByTagName('html')[0];
    return language?.getAttribute('lang');
}

export function getLanguagePathPrefix() {
    const currentLanguage = getLanguage();
    let pathPrefix = '/';
    LANGUAGES.forEach((language) => {
        if (language.lang === currentLanguage) {
            pathPrefix = language.pathPrefix;
        }
    });

    return pathPrefix;
}

export const LANGUAGES = [
    {
        label: 'fr',
        pathPrefix: '/',
        lang: 'fr-FR',
    },
    { label: 'en', pathPrefix: '/en', lang: 'en-US' },
] as const;
